module.exports = __webpack_public_path__ + "static/media/logo-innovate.90ef7bf1.png";